"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if given date is after specified date.
 *
 * @export
 * @class IsAfterValidator
 * @implements {PropertyValidator<Date>}
 */
class IsAfterValidator {
    constructor(date) {
        this.date = date;
    }
    isValid(input) {
        if (input) {
            return input.getTime() > this.date.getTime();
        }
        return false;
    }
}
exports.IsAfterValidator = IsAfterValidator;
//# sourceMappingURL=IsAfterValidator.js.map